import { useState } from 'react'
import { FiTrendingUp, FiX, FiCheck } from 'react-icons/fi'
import toast from 'react-hot-toast'
import { horasExtrasAPI } from '../../services/api'
import { Btn } from '../../ui'

/*
 * ModalHoraExtra (V2) — DS v2.
 * Empleado decide si solicita registrar tiempo extra trabajado.
 */

const fmtMin = (m) => {
  if (!m) return '0m'
  const h = Math.floor(m / 60), min = m % 60
  if (h > 0 && min > 0) return `${h}h ${min}m`
  if (h > 0) return `${h}h`
  return `${min}m`
}

const ModalHoraExtraV2 = ({ fichajeId, minutosExtra, minutosTurno, onClose, onSuccess }) => {
  const [motivo, setMotivo] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSolicitar = async () => {
    setLoading(true)
    try {
      await horasExtrasAPI.crear({ fichaje_id: fichajeId, motivo: motivo.trim() || null })
      toast.success('Solicitud de hora extra enviada')
      onSuccess?.()
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error al enviar solicitud')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="ui-card w-full max-w-sm">
        {/* Cabecera */}
        <div className="flex flex-col items-center text-center px-6 pt-6 pb-4">
          <div className="w-14 h-14 rounded-full bg-[rgba(37,99,235,.10)] flex items-center justify-center mb-3">
            <FiTrendingUp size={22} className="text-[var(--brand-1)]" />
          </div>
          <div className="eyebrow mb-1">Hora extra</div>
          <h3 className="font-display text-[22px] text-[var(--ink)] leading-tight">¿Solicitar tiempo extra?</h3>
          <p className="text-[12.5px] text-[var(--ink-3)] mt-1">
            Has trabajado más de lo previsto en tu turno.
          </p>
        </div>

        {/* Desglose */}
        <div className="mx-6 mb-5 rounded-soft bg-[rgba(37,99,235,.04)] border border-[rgba(37,99,235,.15)] p-4 space-y-2">
          {minutosTurno != null && (
            <div className="flex justify-between text-[12.5px]">
              <span className="text-[var(--ink-3)]">Turno previsto</span>
              <span className="font-mono tnum text-[var(--ink-2)]">{fmtMin(minutosTurno)}</span>
            </div>
          )}
          <div className="flex justify-between text-[12.5px]">
            <span className="text-[var(--ink-3)]">Tiempo trabajado</span>
            <span className="font-mono tnum text-[var(--ink-2)]">
              {minutosTurno != null ? fmtMin(minutosTurno + minutosExtra) : fmtMin(minutosExtra)}
            </span>
          </div>
          <div className="border-t border-[rgba(37,99,235,.15)] pt-2 flex justify-between text-[13px] font-medium">
            <span className="text-[var(--brand-1)]">Tiempo extra</span>
            <span className="text-[var(--brand-1)] font-mono tnum">+ {fmtMin(minutosExtra)}</span>
          </div>
        </div>

        {/* Motivo */}
        <div className="px-6 mb-5">
          <label className="eyebrow block mb-1.5">
            Motivo <span className="text-[var(--ink-3)] font-normal normal-case tracking-normal">(opcional)</span>
          </label>
          <textarea
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
            placeholder="Ej: Reunión urgente con cliente, entrega de proyecto…"
            className="w-full px-3 py-2 bg-[var(--bg-2)] border border-[var(--line)] rounded-soft text-[13px] resize-none focus:outline-none focus:border-[var(--ink-3)] h-20"
            autoFocus
          />
        </div>

        {/* Acciones */}
        <div className="px-6 pb-6 flex gap-3">
          <Btn variant="ghost" className="flex-1" onClick={onClose} disabled={loading}>
            <FiX size={13} /> Ahora no
          </Btn>
          <Btn variant="primary" className="flex-1" onClick={handleSolicitar} disabled={loading}>
            {loading ? 'Enviando…' : <><FiCheck size={13} /> Solicitar</>}
          </Btn>
        </div>
      </div>
    </div>
  )
}

export default ModalHoraExtraV2
